import { Component, OnInit, ViewChild, Input, ChangeDetectorRef, forwardRef } from '@angular/core';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { Results, ResultFilter, PlatformApiService } from 'src/app/services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { AssessmentService } from 'src/app/services/assessment.service';
import { Account, RoleType } from 'src/app/models/AccountModel';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { SettingsWizardComponent } from './settings-wizard-dialog.component';

@Component({
  selector: 'cw-ci-account-sub-accounts',
  templateUrl: './account-sub-accounts.component.html',
  styleUrls: ['./account-sub-accounts.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => AccountSubAccountsComponent)}]
})
export class AccountSubAccountsComponent extends WizardScreenComponent {
  @ViewChild(DataTableComponent) subAccountDataTable: DataTableComponent;
  accountList: Results;
  @Input()
  account: Account;
  RoleType = RoleType;

  constructor(private _apiService: PlatformApiService, public sessionService: SessionService, public dialog: MatDialog) {
    super();
  }

  onLoad() {
    this.subAccountDataTable.executeLoadItems();
    super.onLoad();
  }

  refresh() {
    this.subAccountDataTable.executeLoadItems();
  }

  getRiskColor(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskColor({score});
  }

  getRiskLabel(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskLabel({score});
  }

  loadAccounts(filter = new ResultFilter()) {
    this.subAccountDataTable.showProcessing();
    console.log('loading sub accounts');
    const accountListObservable = this._apiService.getSubAccounts(this.account.id, filter);
    accountListObservable.subscribe(results => {
      this.accountList = results;
      console.log('SubAccountSummaryList.loadAccounts', results);
    })
  }

  isSelectable(account) {
    return account.isActive;
  }

  selectAccount(account) {
    const dialogRef = this.dialog.open(SettingsWizardComponent, {
      panelClass: 'flush-dialog',
      disableClose: true,
      autoFocus: false,
      data: {
        selectedAccount: account,
        parentAccount: this.account,
        startingMenuItem: 'ACCOUNT_START'
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.refresh();
    });
  }

  deleteAccount(account) {
    const pMessage = account.isActive ? 'Are you sure you want to deactivate this company?' : 'Are you sure you want to permanently delete this company?';
    const statusMsg = account.isActive ? 'Deactivating company...' : 'Deleting company...';

    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: [pMessage],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm == 'YES') {
        this.subAccountDataTable.showProcessing(statusMsg);

        this._apiService.deleteAccount(account.id).subscribe(
          resp => {
            this.subAccountDataTable.executeLoadItems();
          }
        );
      }
    });
  }

  isDirty() {
    return false;
  }

  isValid() {
    return true;
  }
}
